import { c as _c } from "react/compiler-runtime";
import { BottomSheet } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { AutoCaptureKind } from '../../../camera/types';
import InstructionItems from './instruction-item/instruction-item';
import useInstructionItems from './use-instruction-items';
type InstructionProps = {
  onClose: () => void;
  isOpen: boolean;
  autoCaptureKind: AutoCaptureKind;
  autocapture: boolean;
};
const Instructions = t0 => {
  const $ = _c(10);
  const {
    onClose,
    isOpen,
    autoCaptureKind,
    autocapture
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.instructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const instructionItems = useInstructionItems(autoCaptureKind, autocapture);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== instructionItems) {
    t3 = <InstructionItems items={instructionItems} />;
    $[3] = instructionItems;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isOpen || $[6] !== onClose || $[7] !== t2 || $[8] !== t3) {
    t4 = <BottomSheet onClose={onClose} open={isOpen} title={t2}>{t3}</BottomSheet>;
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default Instructions;
function _temp($) {
  return $.title;
}